import type { FaireProductEntity } from "../../entity_types/product";

export const p_us4hzv433n: FaireProductEntity = {
  token: "p_us4hzv433n",
  type: "product",
  name: "Elevate - 12oz-  Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/d3a59193b67fef2f495d3344c7e98447ed23576483d136665aa47d01004dedc3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58be63e887123c8885d0248bd77a52e828e8c44f5105fdc248547654af61bf26.jpeg",
    "https://cdn.faire.com/fastly/9ae722057846dbb92fa3abe8a64abbc8593e8d3ad7bc588b1c5ae5c487b9a537.jpeg",
    "https://cdn.faire.com/fastly/635d40a66f75ac8e80032146f4f0cf0cab9debadc0a1cc39f676b4125f624189.jpeg",
    "https://cdn.faire.com/fastly/0c255438f01beefa6d2322099b190d702b8da115f5523a1c89fbf75679542b82.jpeg",
  ],
  priceDollars: 10.92,
  description:
    "A new espresso project comprised of a rotating single country focus from Central and South America. Elevate is complex with a sweet acidity and velvety mouth-feel. Crisp apples and caramel sweetness make for the perfect pairing with milk.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Source Lima Coffees\n• Tasting Notes Red Apple, Caramel and Pecan Pie\n• Elevation 1,300 - 1,500 meters\n• Region Jaén, Cajamarca, Peru\n• Variety Various\n• Process Wet-Processed\n\nPerfect For: Father's Day gifting",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:08.309Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
